import SmallScreenNav from "./SmallScreenNav";
import BigScreenNav from "./BigScreenNav";
import { SubscriptionType } from "../../../types/Shared";

export interface NavItemInterface {
  name: string;
  path: string;
  icon: (props: React.ComponentProps<"svg">) => JSX.Element;
  subMenu?: SubNavItemInterface[];
  subscription?: SubscriptionType;
  permissions?: string[];
}
export interface SubNavItemInterface {
  name: string;
  path: string;
  permissions?: string[];
}

export default function SidebarNav({
  sidebarOpen,
  closeSideBar,
}: {
  sidebarOpen: boolean;
  closeSideBar: () => void;
}) {
  return (
    <>
      <SmallScreenNav sidebarOpen={sidebarOpen} closeSideBar={closeSideBar} />
      <BigScreenNav />
    </>
  );
}
